<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button
            icon="keyboard_backspace"
            @click="goBack"
            >Back</vs-button
          >
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Verticals</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button v-if="abilities.can('create', 'user-types')"
            icon="add"
            @click="addVertical"
            color="danger"
            type="border"
            >Add</vs-button
          >
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="m-4">
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12">
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="4"
          vs-sm="4"
          vs-xs="12"
        >
          <div class="p-1">
            <span>Search: </span>
          </div>

          <VerticalAutocomplete
            :key="companySearchComponentKey"
            class="searchbox"
            :list="searchVertical"
            :searchOn="'vertical'"
            @event-name="handleChildEvent"
          ></VerticalAutocomplete>
          <vs-icon
            class="pl-5 pointer"
            icon="cancel"
            @click="resetVertical"
            size="small"
          ></vs-icon>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12">
           <vs-button
                    class="ml-20"
            icon="refresh"
            @click="resetAll"
            color="primary"
            >Reset</vs-button
          >

          <!-- <vs-pagination :total="Math.ceil(total/per_page)" v-model="currentx"></vs-pagination> -->
        </vs-col>
      </vs-row>

      <vs-table
        class="mb-10"
        @search="handleSearch"
        @sort="handleSort"
        v-model="selected"
        stripe
        :data="verticals"
      >
        <template slot="thead">
          <!-- <vs-th sort-key="s_no">S No.</vs-th> -->
          <vs-th sort-key="vertical">Vertical</vs-th>
          <vs-th sort-key="vertical_description">Description</vs-th>
          <vs-th sort-key="actions">Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <!-- <vs-td :data="data[indextr]">
              {{ indextr + 1 }}
            </vs-td> -->
            <vs-td :data="data[indextr].vertical">
              {{ data[indextr].vertical }}
            </vs-td>
            <vs-td :data="data[indextr].vertical_description">
              {{ data[indextr].vertical_description }}
            </vs-td>
          
            <vs-td :data="data[indextr].actions">
              <vs-icon v-if="abilities.can('read', 'user-types')"
                class="ml-10 removeButton"
                @click="viewVertical(data[indextr].id)"
                color="success"
                icon="visibility"
              ></vs-icon>
              <vs-icon v-if="abilities.can('update', 'user-types')"
                class="ml-10 removeButton"
                @click="editVertical(data[indextr].id)"
                color="success"
                icon="edit"
              ></vs-icon>
              <vs-icon v-if="abilities.can('delete', 'user-types')"
                class="ml-10 removeButton"
                @click="confirmDeleteVertical(data[indextr].id)"
                color="success"
                icon="delete"
              ></vs-icon>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <template>
        <vs-pagination
          :total="Math.ceil(total / per_page)"
          v-model="currentx"
        ></vs-pagination>
      </template>
    </vx-card>
  </div>
</template>

<script>
import defineAbilitiesFor from '@/config/abilities'
import moduleVerticalManagement from "@/store/vertical-management/moduleVerticalManagement.js";
import VerticalAutocomplete from "@/components/autocomplete/VerticalAutocomplete.vue";
import vSelect from "vue-select";
export default {
  data: () => ({
    abilities : null,
    companySearchComponentKey: 0,
    selected: [],
    log: [],
    verticals: [],
    selected_id: null,
    currentx: 1,
    total: 0,
    clientVerticalList: ['y','n'],
    elomarkVerticalTypes: [],
    size_per_page: [10, 20, 50, 100, 500],
    per_page: 10,
    paginationAttr: {
      page_no: 1,
      per_page: 10
    }
  }),
  components: {
    VerticalAutocomplete,
    "v-select": vSelect,
    moduleVerticalManagement
  },
  watch: {
    currentx: function(val) {
      this.paginationSetPageSize();
    },
    per_page: function(val) {
      this.paginationSetPageSize();
    },
  },
  methods: {
    resetAll(){
       this.resetVertical()

    },
    resetVertical() {
      this.fetchVerticals();
      this.companySearchComponentKey += 1;
    },
    paginationSetPageSize() {
      this.paginationAttr = {
        page_no: this.currentx,
        per_page: this.per_page
      };
      this.fetchVerticals();
    },
    searchVertical(inputValue) {
      return this.$store
        .dispatch("verticalsManagement/searchVertical", inputValue)
        .then(response => {
          if (response) {
            let data = response.data;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name: data[property].vertical
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    addVertical() {
      this.$router.push({ path: "/vertical/add" });
    },
    handleSearch(searching) {
      console.log(`The vertical searched for: ${searching}`);
    },
    handleSort(key, active) {
      console.log(`the vertical ordered: ${key} ${active}`);
    },
    viewVertical(id) {
      this.$router.replace("/vertical/" + id);
    },
    editVertical(id) {
      this.$router.replace("/vertical/edit/" + id);
    },
    handleChildEvent() {
      this.verticals = moduleVerticalManagement.state.verticals.datas;
    },
    confirmDeleteVertical(id) {
      this.selected_id = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete Vertical`,
        accept: this.deleteVertical,
        acceptText: "Delete"
      });
    },
    deleteVertical() {
      this.$store
        .dispatch("verticalsManagement/removeVertical", this.selected_id)
        .then(res => {
          if (res.data.status == "success") {
            this.fetchVerticals();
            this.showDeleteSuccess();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Vertical Deleted",
        text: "The User was successfully deleted"
      });
    },
    fetchVerticals() {
      this.$store
        .dispatch(
          "verticalsManagement/fetchAllVerticals",
          this.paginationAttr
        )
        .then(res => {
          this.verticals =
            moduleVerticalManagement.state.verticals.datas;
          this.total = moduleVerticalManagement.state.verticals.total;
          this.per_page =
            moduleVerticalManagement.state.verticals.per_page;

            console.log(this.verticals)
        })
        .catch(err => {
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  },
  mounted() {
    this.fetchVerticals();
  },
  created() {
    var self = this
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });    
    if (!moduleVerticalManagement.isRegistered) {
      this.$store.registerModule(
        "verticalsManagement",
        moduleVerticalManagement
      );
      moduleVerticalManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}
</style>

<style lang="stylus">
.con-expand-verticals
  .con-btns-vertical
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-rolex
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
